import React from 'react'

const NotFoundError = () => {
  return (
    <div>
        <h2>404 NOT FOUND</h2>
    </div>
  )
}

export default NotFoundError